import { Box, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { ReactNode, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getBarValue, getBgVariant } from "../../util/functions";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";

export default function UploadPolicyContainer({
    children,
    heading,
    subHeading,
    back,
}: {
    children: ReactNode;
    heading: string;
    subHeading: string;
    back: () => void;
}) {
    const isMobile = useMediaQuery("(max-width: 768px)");
    const [scrollPositon, setscrollPositon] = useState(0);
    const theme = useTheme();

    const navigate = useNavigate();

    return (
        <Box
            sx={{
                ...(!isMobile
                    ? {
                          background: `url(${getBgVariant("desktop")})`,
                          backgroundSize: "contain",
                          backgroundRepeat: "no-repeat",
                          backgroundPositionX: "center",
                      }
                    : {}),
                margin: { xs: "0px -20px", sm: "0px 0px 0px 0px" },
                display: "flex",
                flexDirection: "column",
                gap: { sm: "36px", xs: "0px" },

                ...(isMobile
                    ? {
                          "&::before": {
                              content: '""',
                              position: "absolute",
                              width: "100%",
                              height: "100%",
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              background: `url(${getBgVariant()})`,

                              backgroundSize: "contain",
                              backgroundRepeat: "no-repeat",
                              backgroundPositionX: "center",
                              opacity:
                                  1 -
                                  (scrollPositon < 35 ? scrollPositon : 35) /
                                      35,
                              zIndex: 1,
                              pointerEvents: "none",
                          },
                      }
                    : {}),
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    width: { xs: "100%", sm: "770px" },
                    margin: "auto",
                    flexDirection: { xs: "column", sm: "row" },
                    padding: { xs: "24px 16px", sm: "0" },
                    ...(isMobile ? { height: "150px", top: 0 } : {}),
                }}
            />
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    width: { xs: "100%", sm: "770px" },
                    margin: "auto",
                    flexDirection: { xs: "column", sm: "row" },
                    padding: { xs: "24px 16px", sm: "0" },

                    ...(isMobile
                        ? {
                              position: "absolute",
                              top: 0,
                              backgroundColor: `rgba(255, 255, 255, ${
                                  scrollPositon >= 35 ? 1 : 0
                              })`,
                              height:
                                  150 -
                                  (scrollPositon < 70 ? scrollPositon : 70),
                              // transition: 'height 0.5s, background 0.5s',
                              borderBottom: `1px solid rgba(150, 150, 150, ${
                                  (scrollPositon < 35 ? scrollPositon : 35) / 35
                              })`,
                              overflow: "hidden",
                              zIndex: 100,
                          }
                        : {}),
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        flexDirection: { xs: "column", sm: "row" },
                        gap: "10px",
                    }}
                >
                    <Stack direction="row" alignItems={"center"} gap="8px">
                        {getBarValue("navBar") !== "false" && (
                            <KeyboardBackspaceIcon
                                sx={{
                                    color: theme.palette.grey[800],
                                    cursor: "pointer",
                                    width: "32px",
                                    height: "32px",
                                }}
                                onClick={() => back()}
                            />
                        )}
                        {isMobile && (
                            <Typography
                                variant="body3"
                                sx={{
                                    color: theme.palette.text.dark,
                                    opacity:
                                        (scrollPositon < 70
                                            ? scrollPositon
                                            : 70) / 70,
                                }}
                            >
                                {subHeading}
                            </Typography>
                        )}
                    </Stack>
                    <Stack direction="column" gap="4px">
                        <Typography
                            variant="body3"
                            sx={
                                isMobile
                                    ? {
                                          color: theme.palette.text.dark,
                                          opacity:
                                              1 -
                                              (scrollPositon < 70
                                                  ? scrollPositon
                                                  : 70) /
                                                  70,
                                      }
                                    : { color: theme.palette.text.dark }
                            }
                        >
                            {subHeading}
                        </Typography>
                        <Typography
                            variant="h4"
                            sx={{
                                width: { xs: "auto", sm: "auto" },
                                color: theme.palette.text.primary,
                                ...(isMobile
                                    ? {
                                          opacity:
                                              1 -
                                              (scrollPositon < 70
                                                  ? scrollPositon
                                                  : 70) /
                                                  70,
                                      }
                                    : {}),
                            }}
                        >
                            {heading}
                        </Typography>
                    </Stack>
                </Box>
            </Box>
            {isMobile && (
                <img
                    src="https://imtbepublic.s3.ap-south-1.amazonaws.com/Portal+assets/Native+art/Claims.png"
                    alt="claimsIcon"
                    width="126px"
                    height="137px"
                    style={{
                        position: "absolute",
                        bottom: isMobile ? "" : "198px",
                        top: isMobile ? "67px" : "",
                        right: 0,
                    }}
                />
            )}
            <Box
                sx={{
                    alignSelf: "stretch",
                    borderRadius: { sm: "40px", xs: "24px 24px 0 0" },
                    background: "#FFF",
                    width: { xs: "100%", sm: "770px" },
                    boxShadow: {
                        sm: "0px 2px 12px 0px rgba(39, 57, 147, 0.08)",
                        xs: "",
                    },
                    padding: isMobile ? "24px 20px" : "24px",
                    border: "1px solid var(--Components-Outline, #ECEFFF)",
                    margin: "auto",
                    zIndex: 1201,
                }}
            >
                {children}
            </Box>
        </Box>
    );
}
